import React from "react";

export default function ScheduleTask() {
  const tasks = [
    { name: "Download tax rates (Tax.Avalara)", seconds: 604800 },
    { name: "Delete inactive customers (GDPR)", seconds: 86400 },
    { name: "Synchronization (Brevo plugin)", seconds: 43200 },
    { name: "Synchronization (PayPal Zettle plugin)", seconds: 28800 },
    { name: "Clear log", seconds: 3600 },
    { name: "Update currency exchange rates", seconds: 3600 },
    { name: "Delete guests", seconds: 600 },
    { name: "Clear cache", seconds: 600 },
    { name: "Keep alive", seconds: 300 },
    { name: "Send emails", seconds: 60 },
  ];

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
        <h1 className="text-2xl font-semibold text-gray-800">
          Schedule Tasks
        </h1>
        <button className="mt-3 sm:mt-0 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium">
          + Add New Task
        </button>
      </div>

      {/* Info Messages */}
      <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg text-sm mb-3">
        ⚠️ For security purposes, editing tasks is not allowed on the demo site.
      </div>
      <div className="bg-blue-50 text-blue-800 p-4 rounded-lg text-sm mb-6">
        Task period should not exceed 24 days.{" "}
        <a href="#" className="text-blue-600 underline">
          Learn more about scheduled tasks
        </a>
        <br />
        <strong>Note:</strong> Do not forget to restart the application once a
        task has been modified.
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-xl shadow-sm">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3">Name</th>
              <th className="p-3">Seconds (run period)</th>
              <th className="p-3">Enabled</th>
              <th className="p-3">Stop on error</th>
              <th className="p-3">Last start date</th>
              <th className="p-3">Last end date</th>
              <th className="p-3">Last success date</th>
              <th className="p-3">Run now</th>
              <th className="p-3 text-right">Edit</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-50 transition-colors"
              >
                <td className="p-3">{task.name}</td>
                <td className="p-3">{task.seconds}</td>
                <td className="p-3">
                  <input type="checkbox" className="w-4 h-4" />
                </td>
                <td className="p-3">
                  <input type="checkbox" className="w-4 h-4" />
                </td>
                <td className="p-3 text-gray-500">—</td>
                <td className="p-3 text-gray-500">—</td>
                <td className="p-3 text-gray-500">—</td>
                <td className="p-3">
                  <button className="px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700">
                    Run Now
                  </button>
                </td>
                <td className="p-3 text-right">
                  <button className="px-3 py-1 text-sm bg-gray-200 rounded-lg hover:bg-gray-300">
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        <p>Previous | Next</p>
        <p>Show 15 items</p>
        <p>1–10 of 10 items</p>
      </div>
    </div>
  );
}
